class MiniCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
     
      if(this.closest('mini-cart-items') != null){
        //console.log("mini-cart",this.closest('mini-cart-items'));
      this.closest('mini-cart-items').updateQuantity(this.dataset.index, 0);
      }

    });
  }
}

customElements.define('mini-cart-remove-button', MiniCartRemoveButton);

class MiniCartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if(event.target.value>=1){
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }else{
      this.querySelector('.quantity__input').value = 1;
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-main-cart-items',
        section: document.getElementById('mini-main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'mini-main-cart-footer',
        section: document.getElementById('mini-main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    console.log(line, quantity, name , "line");

    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        //console.log("response",response)
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        //console.log("parsedState",parsedState.item_count)

        if(parsedState.item_count == 0){
          var html = '';
          html+='<div class="cart__warnings">'
          html+='<img src="https://cdn.shopify.com/s/files/1/0611/8391/8243/files/empty-cart.webp?v=1652350234">'
          html+='<h1 class="cart__empty-text">Your basket is empty.</h1>'

          html+='<p class="cart__login-paragraph">If you need to save your basket, <br>please <a href="account/login">Sign In</a> or <a href="account/register">Register.</a>'
          html+='</p>'
   
          html+='</div>'
          var emptyTag = document.querySelectorAll("#mini-main-cart-items");
          emptyTag[0].innerHTML = html;

          document.querySelectorAll(".cart-count-bubble")[0].remove();
          document.querySelectorAll(".table_color")[0].remove();

          
        }
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('mini-main-cart-footer');
            //console.log("cartFooter",cartFooter)
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        //document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    //console.log("updateLiveRegions",this.currentItemCount , itemCount)
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('mini-main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('mini-main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('mini-cart-items', MiniCartItems);

//